__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-servicing-internet-root'].baseUrl;
import ModuleContainer from './components/AxpServicingInternetRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.6.3',
      module: require('@americanexpress/one-app-module-wrapper')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-servicing-internet-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-servicing-internet-root';
}